export class AccountingDocument {
  public documentNumber: string;
  public status: AccountingDocumentStatus;
  public paidDate?: string | Date;
  public documentDate?: string | Date;
  public dueDate?: string | Date;
  public salesOrderNumber?: string;
  public customerPurchaseOrderNumber?: string;
  public outstandingValue?: number;
  public totalPriceIfPaidToday?: number; // unused, but safekeeping for feature flag
  public totalDocumentAmount?: number;
  public currencyCode: string;
  public referenceId: number;
  public voucher: string;

  public loading?: boolean;

  // ToDo SF1 props remove when we are out of SF1
  public totalPrice?: number;
  public transactionDate?: string | Date;
}

export enum AccountingDocumentStatus {
  Soon = 'Soon',
  Settled = 'Settled',
  InProgress = 'In Progress',
  Open = 'Open',
  Overdue = 'Overdue',
}
